module.exports = __webpack_public_path__ + "static/media/credibilityCapitalLogo.a9287a2e.png";